const DriverProfilePage = () => {
  return (
    <div className="h-screen w-screen">
      <h1>Hello this is the driver profile page</h1>
    </div>
  );
};

export default DriverProfilePage;
